export function debounceCallback(func, delay) {
    let timeoutId;
    return () => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(func, delay);
    };
}
//# sourceMappingURL=debounceCallback.js.map